if (!customElements.get('relode-editorial-article')) {
  customElements.define('relode-editorial-article', class extends HTMLElement {
    connectedCallback() {
      const body = this.querySelector('[data-editorial-body]');
      const aside = this.querySelector('[data-editorial-aside]');
      const list = this.querySelector('[data-editorial-links]');
      if (!body || !aside || !list || this.initialized) return;
      this.initialized = true;
      const headings = [...body.querySelectorAll('h2, h3, h4, h5, h6')].filter(heading => heading.textContent.trim());
      if (headings.length < 2) return;
      const fragment = document.createDocumentFragment();
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${this.id}-heading-${index + 1}`;
        heading.tabIndex = -1;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        fragment.append(item);
      });
      list.replaceChildren(fragment);
      aside.hidden = false;
      this.classList.add('relode-editorial__reading-layout--with-contents');
      this.media = window.matchMedia('(min-width: 990px)');
      this.onViewportChange = () => { this.querySelector('[data-editorial-contents]').open = this.media.matches; };
      this.onViewportChange();
      this.media.addEventListener('change', this.onViewportChange);
      this.onContentsClick = (event) => {
        const link = event.target.closest('a');
        if (!link || !list.contains(link)) return;
        const heading = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!heading || !body.contains(heading)) return;
        heading.focus({ preventScroll: true });
      };
      list.addEventListener('click', this.onContentsClick);
    }

    disconnectedCallback() {
      this.media?.removeEventListener('change', this.onViewportChange);
      this.querySelector('[data-editorial-links]')?.removeEventListener('click', this.onContentsClick);
      this.initialized = false;
    }
  });
}
